"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndividualOptionItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _i18n = require("../../../../i18n/i18n");
var _selectV = require("../../../selectV2");
var _ContactPickerContactName = require("./ContactPickerContactName");
var _ContactPickerDetailItem = require("./ContactPickerDetailItem");
const IndividualOptionItem = _ref => {
  let {
    option,
    internalInputValue,
    optionToString
  } = _ref;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const {
    name,
    emailAddress
  } = option;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, option.name ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ContactPickerContactName.ContactPickerContactName, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the name in the contact card. The comma is important so screen readers can provide a short pause between the 'Name' label and the contact's name",
      id: "Name, {name}",
      values: {
        name
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_selectV.FuzzySearchResult, {
    option: option,
    optionToString: optionToString,
    inputValue: internalInputValue
  })), /*#__PURE__*/_react.default.createElement(_ContactPickerDetailItem.ContactPickerDetailItem, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the email in the contact card. The comma is important so screen readers can provide a short pause between the 'Email' label and the contact's email",
      id: "Email, {emailAddress}",
      values: {
        emailAddress
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_selectV.FuzzySearchResult, {
    option: option,
    optionToString: option => option.emailAddress,
    inputValue: internalInputValue
  }))) : /*#__PURE__*/_react.default.createElement(_ContactPickerContactName.ContactPickerContactName, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the email in the contact card. The comma is important so screen readers can provide a short pause between the 'Email' label and the contact's email",
      id: "Email, {emailAddress}",
      values: {
        emailAddress
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_selectV.FuzzySearchResult, {
    option: option,
    optionToString: option => option.emailAddress,
    inputValue: internalInputValue
  })));
};
exports.IndividualOptionItem = IndividualOptionItem;
//# sourceMappingURL=IndividualOptionItem.js.map